import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

const useArtistKlydoStats = (userId: string) => {
  return useQuery({
    queryKey: ["artistKlydoStats", userId],
    queryFn: () => adminApiClient.getArtistKlydoStats(userId),
  });
};

export default useArtistKlydoStats;
